import { useState } from 'react';
import { Box, Container } from '@mui/material';
import { ForgotPasswordForm } from '../../components/features/auth';
import { authService } from '../../services';
import type { ForgotPasswordRequest } from '../../types';

export function ForgotPasswordPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (data: ForgotPasswordRequest) => {
    setIsLoading(true);
    setError(null);
    try {
      await authService.forgotPassword(data);
      setSuccess(true);
    } catch (err: unknown) {
      const error = err as { response?: { data?: { detail?: string } } };
      setError(error.response?.data?.detail || '이메일 전송에 실패했습니다');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.50',
      }}
    >
      <Container maxWidth="sm">
        <ForgotPasswordForm
          onSubmit={handleSubmit}
          isLoading={isLoading}
          error={error}
          success={success}
        />
      </Container>
    </Box>
  );
}
